import { render, staticRenderFns } from "./DispensationsTable.vue?vue&type=template&id=102664ae"
import script from "./DispensationsTable.vue?vue&type=script&lang=js"
export * from "./DispensationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports